var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatientsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FABB18"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1570_5930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5984 39.5996V37.5996C35.5984 36.5387 35.177 35.5213 34.4269 34.7712C33.6767 34.021 32.6593 33.5996 31.5984 33.5996H23.5984C22.5376 33.5996 21.5202 34.021 20.77 34.7712C20.0199 35.5213 19.5984 36.5387 19.5984 37.5996V39.5996",
    stroke: "white",
    strokeWidth: 1.57828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6016 21.5996C26.5407 21.5996 25.5233 22.021 24.7731 22.7712C24.023 23.5213 23.6016 24.5387 23.6016 25.5996C23.6016 26.6605 24.023 27.6779 24.7731 28.428C25.5233 29.1782 26.5407 29.5996 27.6016 29.5996C28.6624 29.5996 29.6798 29.1782 30.43 28.428C31.1801 27.6779 31.6016 26.6605 31.6016 25.5996C31.6016 24.5387 31.1801 23.5213 30.43 22.7712C29.6798 22.021 28.6624 21.5996 27.6016 21.5996Z",
    stroke: "white",
    strokeWidth: 1.57828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6016 39.5985V37.5985C41.6009 36.7122 41.3059 35.8513 40.7629 35.1508C40.2199 34.4504 39.4597 33.9501 38.6016 33.7285",
    stroke: "white",
    strokeWidth: 1.57828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5984 21.7285C35.4589 21.9488 36.2215 22.4492 36.7661 23.1508C37.3107 23.8524 37.6063 24.7153 37.6063 25.6035C37.6063 26.4917 37.3107 27.3546 36.7661 28.0562C36.2215 28.7578 35.4589 29.2582 34.5984 29.4785",
    stroke: "white",
    strokeWidth: 1.57828,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1570_5930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18.6 18.5996)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsIcon);
export default __webpack_public_path__ + "static/media/patientsIcon.47d93f7657237d6c162afcfc7116fbd1.svg";
export { ForwardRef as ReactComponent };